import styled from "styled-components";

export const NavMenu = styled.nav`
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  align-items: center;
  gap: 1rem;
  position: 'relative';
`;

export const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  h2 {
    color: #fff;
    /* font-size: 40px; */
  }
`;
